/**
 * Work Order screen color definitions
 */
import { palette, createColor } from './palette.colors';

export const workOrderColors = {
  titleColor: createColor(palette.gray.darkest, palette.dark.text),
  sortBG: createColor(palette.gray.darkest, palette.dark.surface),
  sortBGAlt: createColor(palette.gray.border, palette.gray.border),
  sortBorder: createColor(palette.dark.borderLight, palette.gray.borderLight),
  sortBorderAlt: createColor(palette.gray.border, palette.dark.techBorder),
  sortSelectedText: createColor(palette.blue.onTint, palette.gray.white),
  dropdownPlaceholderText: createColor(palette.blue.onTint, palette.dark.textAlt),
  sortByText: createColor(palette.gray.dark, palette.gray.zinc),
  icon: createColor(palette.gray.charcoal, palette.gray.border),
  tileViewIcon: createColor(palette.gray.lightWhite, palette.dark.textAlt),
  tileViewSelectedIcon: createColor(palette.gray.almostBlack, palette.gray.subText),
  tileViewIconBorder: createColor(palette.borders.dropdownBlue, palette.gray.darkGreyLight),
  listViewIconColor: createColor(palette.gray.almostBlack, palette.gray.white),
  listViewSelectedIconColor: createColor(palette.gray.almostBlack, palette.dark.textAlt),
  sortBackground: createColor(palette.gray.darkest, palette.dark.surface),
  filterBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  filterSelectedText: createColor(palette.gray.darkest, palette.gray.white),
  filterSelectedTextBorder: createColor(palette.blue.primary, palette.gray.white),
  workOrderFilterTextBorder: createColor(palette.blue.primary, palette.blue.primary),
  workOrderStatusSelectedTextBorder: createColor(palette.borders.selected, palette.borders.selected),
  workOrderStatusSelectedTextBG: createColor(palette.blue.sky, palette.dark.cardSelected),
  workOrderStatusSelectedText: createColor(palette.gray.darkest, palette.dark.text),
  workOrderStatusTextBorder: createColor(palette.borders.selected, palette.borders.selected),
  workOrderStatusTextBG: createColor(palette.opacity.gray80alt, palette.dark.cardSelected),
  workOrderStatusText: createColor(palette.gray.darkest, palette.dark.textAlt),
  filterText: createColor(palette.gray.dark, palette.dark.textLight),
  filterDropdownTextColor: createColor(palette.dark.textLight, palette.dark.textLight),
  filterDropdownSelectedTextBG: createColor(palette.dark.borderLight, palette.dark.borderLight),
  filterDropdownSelectedTextColor: createColor(palette.gray.white, palette.gray.white),
  filterDropdownMenuSelectedTextBG: createColor(palette.dark.menu, palette.dark.menu),
  filterDropdownMenuSelectedTextBorder: createColor(palette.dark.borderLight, palette.dark.borderLight),
  viewAllCTAText: createColor(palette.blue.darkest, palette.gray.white),
  cardBorder: createColor(palette.gray.border, palette.dark.borderLight),
  cardListTitle: createColor(palette.gray.darker, palette.gray.white),
  cardListSubTitle: createColor(palette.gray.dark, palette.gray.text),
  cardIconBG: createColor(palette.backgrounds.lightBlue, palette.dark.cardAlt),
  statusBG: createColor(palette.gray.white, palette.gray.card),
  statausBorder: createColor(palette.gray.divider, palette.dark.borderAlt),
  statusTitle: createColor(palette.gray.darkest, palette.gray.white),
  statusDate: createColor(palette.dark.borderLight, palette.gray.text),
  statusDateTitle: createColor(palette.gray.dark, palette.gray.text),
  statusDateBG: createColor(palette.special.transparent, palette.gray.darkest),
  statusDateBorder: createColor(palette.gray.borderAlt2, palette.dark.statusDate),
  statusDateIcon: createColor(palette.dark.textLight, palette.gray.border),
  statausCalenderBG: createColor(palette.gray.white, palette.dark.borderLight),
  headerCalenderBG: createColor(palette.blue.primary, palette.blue.primary),
  headerCalenderSelectedText: createColor(palette.blue.secondary, palette.gray.white),
  idBGColor: createColor(palette.opacity.whiteB2, 'transparent'),
  idTextColor: createColor(palette.gray.lightDarkGrey, palette.gray.disabledCTABG),
  idValueColor: createColor(palette.blue.onTint, palette.blue.selectedBorder),
  notificationIconColor: createColor(palette.gray.dark, palette.dark.textAlt),
  notificationBGColor: createColor(palette.gray.lightWhite, palette.dark.content),
  notificationCountBGColor: createColor(palette.blue.primary, palette.blue.primary),
  notificationCountTextColor: createColor(palette.gray.white, palette.gray.white),
  repairNumber: createColor(palette.gray.dark, palette.gray.dark),
  partsAssignedDisabledBG: createColor(palette.opacity.grey20, palette.opacity.grey20),
  partsAssignedDisabledBorder: createColor(palette.gray.neutral, palette.gray.neutral),
  partsAssignedDisabledIcon: createColor(palette.gray.darkest, palette.gray.darkest),
  partsAssigneEnabledIcon: createColor(palette.semantic.darkGreen, palette.semantic.darkGreen),
  partsAssigneEnabledBorder: createColor(palette.opacity.leastPrioriryBorder, palette.opacity.leastPrioriryBorder),
  partsAssignedEnabledBG: createColor(palette.opacity.leastPrioriryBG, palette.opacity.leastPrioriryBG),
};
